import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import GlobalButton from "./GlobalButton";
import { PRIMARY, SECONDARY } from "../styles/color";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../ServiceModule/Service";
import "./CSS/ProductCard.css";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ageImageFlage from "../Images/Red-flag.png";
import { Tooltip } from "@mui/material";
import { useCallback } from "react";
import { useMemo } from "react";
import { useThemeColors } from "../Context/Theme";
import debounce from "lodash.debounce";


const ProductCard = ({
  offer,
  ageRestriction,
  productName,
  productType,
  categoryId,
  sku,
  price,
  image,
  discount,
  offerDiscount,
  productId,
  buttonText = "Add to Cart",
  onClick,
  onUnitSelect,
  addQuantity,
  removeQuantity,
  product,
  ageImage,
  handleChangeQuantity,
  style = {},
  imageStyle = {},
  blankQuantitySku,
  selectedSkuQuantity
}) => {
  const {
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors()
  const [skuId, setSkuId] = useState(() => product?.skus[0]?.sku_id || null);
  const [selectedSku, setSelectedSku] = useState(() => ({
    ...product,
    skus: product?.skus ? [product?.skus[0]] : [],
  }));
  const cartItem = useSelector((state) =>
    state.cart.items.find(
      (item) => item?.product_details?.product_id === productId && item?.sku_id === (skuId || sku[0]?.sku_id)
    )
  );
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  useEffect(() => {
    if (product?.skus && product.skus.length > 0) {
      setSkuId(product?.skus?.filter(i => i.sku_status === 1)[0]?.sku_id);
      setSelectedSku({
        ...product,
        skus: [product?.skus?.filter(i => i.sku_status === 1)[0]],
      });
    }
  }, [product, navigate]);

  const quantity = blankQuantitySku?.find(i => i === skuId) ? "" : selectedSkuQuantity?.find(n => n.skuId === skuId) ? selectedSkuQuantity?.find(n => n.skuId === skuId)?.quantity : cartItem?.quantity ? cartItem?.quantity : 0;

  const handleSkuSelection = useCallback((product, id) => {
    setSkuId(id);
    const selectedSku = product?.skus.filter((sku) => sku.sku_id === id);
    const filteredProduct = {
      ...product,
      skus: selectedSku.length > 0 ? selectedSku : [product?.skus[0]],
    };
    setSelectedSku(filteredProduct);

    onUnitSelect(product, id);
  }, [onUnitSelect]);

  const fetchProducts = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/product/getProductById?product_id=${productId}`
      );
      navigate(`/events/${eventName}/product-detail/${productId}`);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Error fetching product:", err);
    }
  }, [productId, navigate, eventName]);

  const filteredSkus = useMemo(() => {
    return sku?.filter((item) => item?.sku_status === 1) || [];
  }, [sku]);

  const handleCategoryClick = (categoryId) => {
    navigate(`/events/${eventName}/shop`, { state: { category: categoryId } });
  };
  if (product?.skus?.every((sku) => sku?.sku_status === 0)) {
    return null;
  }

  const debouncedHandleChangeQuantity = debounce((value, product) => {
    handleChangeQuantity(value, product);
  }, 100);

  return (
    <Card
      style={{
        borderRadius: "20px",
        position: "relative",
        border: "0.92px solid #E0E0E0",
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
        justifyContent: "space-between",
        width: "250px",
        ...style,
        fontFamily
      }}
    >
      {product?.offers?.length > 0 &&
        product?.offers[0]?.required_coupon_apply_price ===
        "Apply to Price" && (
          <div className="offer-container">
            <div className="text-overlay">
              {product?.offers[0]?.discount_fixed === "Discount" ? (
                <>
                  <span
                    style={{
                      fontSize: "0.6em",
                      color: "white",
                      fontWeight: "600",
                      fontFamily
                    }}
                  >
                    {product?.offers[0]?.discount_fixed_amount}%
                  </span>
                  <div
                    style={{
                      fontSize: "0.6em",
                      color: "white",
                      fontWeight: "600",
                      fontFamily
                    }}
                  >
                    Off
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.6em",
                      color: "white",
                      fontWeight: "700",
                    }}
                  >
                    Flat
                  </div>
                  <span
                    style={{
                      fontSize: "0.6em",
                      color: "white",
                      fontWeight: "700",
                      fontFamily
                    }}
                  >
                    {"\n"} ${product?.offers[0]?.discount_fixed_amount}
                  </span>
                  <div
                    style={{
                      fontSize: "0.6em",
                      color: "white",
                      fontWeight: "700",
                      fontFamily
                    }}
                  >
                    Off
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      {product?.categories[0]?.age_validation !== "No" && (
        <div
          style={{
            position: "absolute",
            top: "-1rem",
            right: "20px",
            width: "15%",
            height: "25%",

            zIndex: 1,
            backgroundImage: `url(${ageImageFlage})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.5rem",
            textAlign: "center",
          }}
        >
          <p style={{ margin: 0, padding: 0, fontSize: "0.6rem", fontFamily }}>
            {product?.categories[0]?.age_validation}+<br />
            only
          </p>
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <img
          src={image}
          alt={productName}
          style={{
            width: "40%",
            height: "15vh",
            objectFit: "contain",
            cursor: "pointer",
            ...imageStyle
          }}
          loading="lazy"
          onClick={fetchProducts}
        />
      </div>

      <CardContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span style={{ fontSize: "11px", fontWeight: "500", color: PRIMARY, cursor: "pointer", fontFamily }}
            onClick={() => handleCategoryClick(categoryId)}

          >
            {productType}
          </span>
          {/* <span
            style={{
              fontSize:"15px",
              fontWeight: "600",
              margin: "0.7em 0",
              cursor: "pointer",
              fontFamily: fontFamilyHeading
            }}
            onClick={fetchProducts}
          >
            {productName}
          </span> */}
          <Tooltip title={productName} arrow placement="top">
            <span
              style={{
                fontSize: "15px",
                fontWeight: "600",
                margin: "0.7em 0",
                cursor: "pointer",
                fontFamily: fontFamilyHeading,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: "190px",
              }}
              onClick={fetchProducts}
            >
              {
                productName
              }
            </span>
          </Tooltip>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.2em" }}>
          {filteredSkus
            ?.slice(0, 2)
            .map((item) => {
              const isSelected = selectedSku?.skus[0]?.sku_id === item.sku_id;

              return (
                <Tooltip
                  key={item?.sku_id}
                  title={item?.unit + (item && item.secondaryunit ? ", " + item?.secondaryunit : "")}
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#333",
                        color: "#fff",
                        fontSize: "12px",
                        borderRadius: "4px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#333",
                      },
                    },
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#797979",
                      backgroundColor: isSelected ? SECONDARY : "#FFFFFF",
                      border: `1px solid ${isSelected ? "#FFCBCC" : "#888888"}`,
                      borderRadius: "8px",
                      padding: "8px",
                      cursor: "pointer",
                      maxWidth: "70px",
                      maxHeight: "40px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      fontFamily
                    }}
                    onClick={() => handleSkuSelection(product, item.sku_id)}
                  >
                    {item?.unit.length > 10 ? `${item?.unit.slice(0, 10)}...` : item?.unit} ,
                    <br />
                    {item && item?.secondaryunit && item?.secondaryunit.length > 10 ? `${item?.secondaryunit.slice(0, 10)}...` : item?.secondaryunit}
                  </p>
                </Tooltip>
              );
            })}
          {filteredSkus?.length > 2 && (
            <p
              style={{
                fontSize: "10px",
                fontWeight: "500",
                color: "#797979",
                backgroundColor: "#FFFFFF",
                border: "1px solid #888888",
                borderRadius: "8px",
                padding: "8px",
                cursor: "pointer",
                width: "60px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily
              }}
              onClick={fetchProducts}
            >
              +{filteredSkus?.length - 2} more
            </p>
          )}
        </div>


        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "2px",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "700",
                fontFamily,
                margin: 0,
              }}
            >
              {parseFloat(selectedSku?.skus[0]?.discount_amount) > 0 || parseFloat(selectedSku?.skus[0]?.discount_price) > 0
                ? `$${parseFloat(selectedSku?.skus[0]?.discount_price).toFixed(
                  2
                )}` || 0
                : `$${parseFloat(selectedSku?.skus[0]?.regular_price).toFixed(
                  2
                )}` || 0}
            </p>
            {(discount > 0 || offerDiscount > 0) && (parseFloat(selectedSku?.skus[0]?.regular_price)?.toFixed(2) != parseFloat(selectedSku?.skus[0]?.discount_price)?.toFixed(2)) && (
              <p
                style={{
                  fontSize: "12px",
                  textDecoration: "line-through",
                  fontFamily,
                  margin: 0,
                }}
              >
                $
                {parseFloat(selectedSku?.skus[0]?.regular_price).toFixed(2) ||
                  0}
              </p>
            )}
          </div>
          <div className="button-container">
            {(quantity > 0 || quantity === "") && quantity !== null && quantity !== undefined ? (
              <div style={styles.quantityContainer}>
                <button style={styles.button} onClick={removeQuantity}>
                  -
                </button>
                <input
                  type="number"
                  step="1"
                  min="0"
                  max="9999"
                  value={quantity ?? ""}
                  style={{ ...styles.input, fontFamily }}
                  onChange={(e) => {
                    const val = e.target.value;

                    if (val === "") {
                      debouncedHandleChangeQuantity("", product);
                      return;
                    }

                    const value = parseInt(val, 10);

                    if (!isNaN(value) && value >= 0 && value <= 9999) {
                      debouncedHandleChangeQuantity(value, product);
                    }
                  }}
                  onFocus={(e) => e.target.select()}
                  onKeyDown={(e) => {
                    if (e.key === '.' || e.key === ',' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                />


                <button style={styles.button} onClick={addQuantity}>
                  +
                </button>
              </div>
            ) : (
              <div style={{ width: "80%" }}>
                <GlobalButton
                  text={buttonText}
                  startIcon={<ShoppingCartIcon />}
                  size="small"
                  height="4.5vh"
                  width="100%"
                  onClick={addQuantity}
                  border="0.96px solid #379246"
                />
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default React.memo(ProductCard);

const styles = {
  container: {
    borderRadius: "26px",
    border: "1px solid #D9D9D9",
    width: "45%",
    maxWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    padding: "5px 10px",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#F6F2F2",
    border: "none",
    borderRadius: "20px",
    width: "30%",
    height: "100%",
    cursor: "pointer",
    fontSize: "18px",
  },
  input: {
    width: "40%",
    textAlign: "center",
    border: "none",
    outline: "none",
    fontSize: "16px",
  },
  quantityContainer: {
    width: "100%",
    disply: "flex",
    border: "1px solid #D9D9D9",
    borderRadius: "1rem",
  },
};
